<template>
  <div class="card center nubii-color" style="min-height: 70px">
    <div>
      <h1>{{ $i18n.t("admin.dashboard.welcome") }}</h1>
      <p>{{ $i18n.t("admin.dashboard.welcomeDescription") }}</p>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "welcome-dashboard-component",
})
export default class WelcomeDashboardComponent extends Vue {}
</script>
<style lang="scss">
.nubii-color {
  background: rgb(43, 61, 142);
  background: linear-gradient(
    90deg,
    rgba(43, 61, 142, 1) 0%,
    rgba(4, 167, 233, 1) 100%
  );
  h1 {
    color: white;
    margin: 0px;
  }
  p {
    font-size: 12px;
    color: white;
    margin: 0px;
  }
}
</style>
